import React from 'react';
// import { ReactComponent as Icon } from '../../assets/images/icon-content.svg';
// import Icon from '../../assets/images/icon-content.svg';
import $ from 'jquery';
import './SpiderLabel.scss';

const SpiderLabel = ({ name, updateLabel, active, index, x, y, ...props }) => {

  const onActivate = () => {
    if ($('html').width() > 768) {
      props.spiderLabelClick(name);
    }
    updateLabel(index);
  };
  return (
    <g width="280" transform={`translate(${x},${y})`} className='spider-labelGroup' onClick={onActivate}>
      <Text
        {...props}
        active={active !== index}
        width={180}
        className={active === index ? 'spider-results-label active' : 'spider-results-label'}
        textAnchor='middle'
        x={0}
        y={0}
        lineHeight={1.2}
      >
        {name.toUpperCase()}
      </Text>
    </g>
  );
};

export default SpiderLabel;

class Text extends React.Component {
  static defaultProps = {
    lineHeight: 1,
    capHeight: 1,
  };

  constructor(props) {
    super(props);

    this.state = {
      lines: [],
    };
  }

  componentWillMount() {
    const { wordsWithComputedWidth, spaceWidth } = this.calculateWordWidths();
    this.wordsWithComputedWidth = wordsWithComputedWidth;
    this.spaceWidth = spaceWidth;

    const lines = this.calculateLines(this.wordsWithComputedWidth, this.spaceWidth, this.props.width);
    this.setState({ lines });
  }

  render() {
    // TODO: determine lineHeight and dy dynamically (using passed in props)
    const { lineHeight, capHeight, key, ...props } = this.props;
    const dy = capHeight;
    const { x, y } = props;

    return (
      <text {...props} dy={`${dy}em`} >
        {this.state.lines.map((word, index) => (
          <tspan x={x} y={y} key={index} dy={`${index * lineHeight}em`}>
            {word}
          </tspan>
        ))}
        <tspan className={props.active ? 'tspan' : 'tspan active'} active={props.active}>
          {' '}
        </tspan>
      </text>
    );
  }

  componentDidUpdate(nextProps, nextState) {
    if (this.props.children !== nextProps.children) {
      const { wordsWithComputedWidth, spaceWidth } = this.calculateWordWidths();
      this.wordsWithComputedWidth = wordsWithComputedWidth;
      this.spaceWidth = spaceWidth;
      const lines = this.calculateLines(this.wordsWithComputedWidth, this.spaceWidth, this.props.width);
      this.setState({ lines });
    }
    const lines = this.calculateLines(this.wordsWithComputedWidth, this.spaceWidth, this.props.width);
    const newLineAdded = this.state.lines.length !== lines.length;
    // const wordMoved = this.state.lines.some((line, index) => line.length ? line.length !== lines[index].length : false);
    // Only update if number of lines or length of any lines change

    if (newLineAdded) {
      this.setState({ lines });
    }
  }

  calculateWordWidths() {
    // Calculate length of each word to be used to determine number of words per line
    // console.log(this.props.children);
    const words = this.props.children.split(/\s+/);

    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    var text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
    Object.assign(text.style, this.props.style);
    svg.appendChild(text);
    document.body.appendChild(svg);

    const wordsWithComputedWidth = words.map((word) => {
      text.textContent = word;
      return { word, width: text.getComputedTextLength() };
    });

    text.textContent = '\u00A0'; // Unicode space
    const spaceWidth = text.getComputedTextLength();

    document.body.removeChild(svg);

    return { wordsWithComputedWidth, spaceWidth };
  }

  calculateLines(wordsWithComputedWidth, spaceWidth, lineWidth) {
    const wordsByLines = wordsWithComputedWidth.reduce((result, { word, width }) => {
      const lastLine = result[result.length - 1] || { words: [], width: 0 };

      if (lastLine.words.length === 0) {
        // First word on line
        const newLine = { words: [word], width };
        result.push(newLine);
      } else if (lastLine.width + width + lastLine.words.length * spaceWidth < lineWidth) {
        // Word can be added to an existing line
        lastLine.words.push(word);
        lastLine.width += width;
      } else {
        // Word too long to fit on existing line
        const newLine = { words: [word], width };
        result.push(newLine);
      }

      return result;
    }, []);

    return wordsByLines.map((line) => line.words.join(' '));
  }
}
